export default {
  campaign: () => import("/codebuild/output/src3026441821/src/consort-headless/nuxtapp/layouts/campaign.vue"),
  default: () => import("/codebuild/output/src3026441821/src/consort-headless/nuxtapp/layouts/default.vue")
}